module.exports = __webpack_public_path__ + "static/img_9842_dpp_optimized-eb040996344eb9635bbbce621ef600f1.jpg";